import React, { useCallback } from 'react';
import { Button } from '@framework-controls/core';
import { JSXIf } from '@framework-controls/jsxconditions';
import css from './MenuSlideBtn.module.scss';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';

interface IProps {
    id: string;
    lit?: string;
    icon?: React.ReactElement;
    openFlag: boolean;
    click: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    toolTip?: string;
    theme: string;
    // ref to the bordered wrapper div, for measuring its visual box rather than the click target
    menuButtonRef?: React.Ref<HTMLDivElement>;
    // the button's flyout, rendered inside the bordered wrapper so it can position against that box
    children?: React.ReactNode;
}

const MenuSlideBtn = (props: IProps) => {
    // Set contentsClassName based on openFlag (open flag indicates if the menuSlide is open or closed)
    const contentsClassName = classNames(
        css.menuSlideBtnContents,
        {
            [css.menuSlideBtnContentsIN]: props.theme === 'infiniti',
            [css.menuSlideBtnContentsChecked]: props.openFlag,
            [css.menuSlideBtnContentsCheckedFord]: props.theme === 'ford',
            [css.menuSlideBtnContentsNissan]: props.theme === 'nissan',
            [css.menuSlideBtnContentsGMC]: props.theme === 'gmc',
            [css.menuSlideBtnContentsAcura]: props.theme === 'acura',
        },
    );

    // Set subBtnClassName based on openFlag
    const subBtnClassName = classNames(
        css.menuSlideSubBtn,
        {
            [css.menuSlideSubBtnChecked]: props.openFlag,
            [css.menuSlideBtnCheckedAudi]: props.openFlag && props.theme === THEME.AUDI,
            [css.menuSlideBtnCheckedChevrolet]: props.openFlag && props.theme === THEME.CHEVROLET,
            [css.menuSlideBtnCheckedBuick]: props.openFlag && props.theme === THEME.BUICK,
            [css.menuSlideBtnCheckedToyotaSPM]: props.openFlag && props.theme === THEME.TOYOTA_SPM,
            [css.menuSlideSubBtnMaz]: props.theme === THEME.MAZDA,
            [css.menuSlideSubBtnGen]: props.theme === THEME.GENESIS,
            [css.menuSlideSubBtnJag]: props.theme === THEME.JAGUAR,
        },
    );

    const onClick = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        props.click(event);
    }, [props.click]);
    // Set displayBtn flag base on if we have a literal for the button.
    // We still want to display the Div wrapper to reserve the space for the button in the menu.
    let displayBtn = true;
    if (!props.lit) {
        displayBtn = false;
    }

    return (
        <div className={subBtnClassName} ref={props.menuButtonRef}>
            <JSXIf Condition={displayBtn}>
                <Button
                    id={props.id + '1'}
                    onClick={onClick}
                    variant={'menuSlideBtn'}
                    type={'custom'}
                    tooltip={props.toolTip ? props.toolTip : ''}
                >
                    <span className={contentsClassName}>
                        {props.icon}
                    </span>
                    <div className={contentsClassName}>{props.lit}</div>
                </Button>
            </JSXIf>
            {props.children}
        </div>
    );
};

export default MenuSlideBtn;